/* Product page extras: the size guide dialog with its size finder, and "choose your size" buttons further down the page. */
(() => {
  const dialog = document.querySelector('#shoe-size-guide');

  document.addEventListener('click', (event) => {
    if (dialog && typeof dialog.showModal === 'function') {
      if (event.target.closest('[data-size-guide-open]')) {
        if (!dialog.open) dialog.showModal();
        return;
      }
      if (event.target === dialog || event.target.closest('[data-size-guide-close]')) {
        dialog.close();
        return;
      }
    }
    if (event.target.closest('[data-scroll-to-buy]')) {
      const form = document.querySelector('[data-shoe-product] .shoe-product-form');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  const finder = document.querySelector('[data-size-finder]');
  if (finder) {
    const usual = finder.querySelector('[data-finder-usual]');
    const result = finder.querySelector('[data-finder-result]');
    const text = finder.querySelector('[data-finder-text]');
    const go = finder.querySelector('[data-finder-select]');
    const fill = (template, size) => template.replace('[size]', size);

    const suggest = () => {
      if (!usual.value) return;
      const options = [...usual.options].filter((option) => option.value !== '');
      const index = Number(usual.value);
      const wide = finder.querySelector('input[name="finder-width"]:checked').value === 'wide';
      const next = wide ? Math.min(index + 1, options.length - 1) : index;
      const size = options[next].dataset.size;
      const label = options[next].dataset.label || size;
      let template = finder.dataset.result;
      if (wide) template = next === index ? finder.dataset.resultMax : finder.dataset.resultWide;
      text.textContent = fill(template, label);
      go.textContent = fill(finder.dataset.select, label);
      go.dataset.size = size;
      result.hidden = false;
    };

    finder.addEventListener('change', suggest);
    go.addEventListener('click', () => {
      const radios = document.querySelectorAll('.shoe-product-form input[data-option-position="' + finder.dataset.optionPosition + '"]');
      const radio = [...radios].find((input) => input.value === go.dataset.size);
      if (radio) radio.click();
      if (dialog) dialog.close();
    });
  }
})();
